import { LinkField, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useMemo } from 'react';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';
import styles from './BannerQuickLinks.module.scss';

type Props = {
  fields: {
    items: {
      displayName: string;
      id: string;
      name: string;
      template: string;
      fields: {
        id: string;
        link: LinkField;
      };
    }[];
    title: string;
  };
};

const BannerQuickLinks = ({ fields }: Props): JSX.Element => {
  const linkFields = useMemo(() => {
    if (!fields?.items.length) return [];
    return fields.items.map((item) => {
      item.fields.id = item.id;
      return item.fields;
    });
  }, [fields]);

  return (
    <div className={`${styles['banner-quick-links']} background-to-change p-3 d-none d-xl-block`}>
      {fields && (
        <Text
          tag="p"
          field={fields.title}
          className="section-header-small background-to-change mb-2"
        />
      )}
      <ul className={styles['links-list']}>
        {linkFields.map((field, idx) => (
          <li key={field.id}>
            <ScLink
              field={field.link}
              className={`${styles['banner-quick-links__link']} quick-link-typography ${
                idx !== 0 ? 'mt-2' : ''
              }`}
              replaceWithSlot={false}
              showExternalIcon={false}
            >
              <span className="text-nowrap">
                <i className="bi bi-chevron-right ms-2" />
              </span>
            </ScLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BannerQuickLinks;
